import React from "react";
import { 
  Drawer, Box, List, ListItem, ListItemButton, Button, Divider
} from "@mui/material";

const MobileDrawer = ({ 
  open, 
  onClose, 
  t, 
  i18n, // Added to detect current language
  changeLanguage, // Added to trigger the switch
  onClickGoToPage, 
  currentView, 
  icons // Passing icons as an object to avoid double imports
}) => {
  const { 
    HomeIcon, 
    InfoOutlinedIcon, 
    GroupsOutlinedIcon, 
    VectorIcon, 
    PostAddOutlinedIcon 
  } = icons;

  const handleAboutClick = () => {
    // Logic from your original component
    if (currentView === "Landing" || window.location.pathname === "/" || window.location.pathname === "/landing") {
      setTimeout(() => {
        const learnMoreSection = document.querySelector('[data-section="learn-more"]');
        if (learnMoreSection) {
          learnMoreSection.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      const eventHandler = onClickGoToPage("Landing");
      eventHandler();
      localStorage.setItem('scrollToLearnMore', 'true');
    }
  };

  const handleStandardNav = (page) => {
    const eventHandler = onClickGoToPage(page);
    eventHandler();
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 100);
  };

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      sx={{ display: { xs: "block", md: "none" } }}
    >
      <Box
        sx={{ width: 250, display: "flex", flexDirection: "column", padding: 2 }}
        role="presentation"
        onClick={onClose}
        onKeyDown={onClose}
      >
        <List>
          {/* Home */}
          <ListItem disablePadding>
            <ListItemButton>
              <Button 
                sx={navButtonStyle} 
                startIcon={<HomeIcon />} 
                onClick={() => handleStandardNav("Landing")}
              >
                {t('nav.home')}
              </Button>
            </ListItemButton>
          </ListItem>

          {/* About / Learn More */}
          <ListItem disablePadding>
            <ListItemButton>
              <Button 
                sx={navButtonStyle} 
                startIcon={<InfoOutlinedIcon />} 
                onClick={handleAboutClick}
              >
                {t('nav.about')}
              </Button>
            </ListItemButton>
          </ListItem>

          {/* Team */}
          <ListItem disablePadding>
            <ListItemButton>
              <Button 
                sx={navButtonStyle} 
                startIcon={<GroupsOutlinedIcon />} 
                onClick={() => handleStandardNav("About")}
              >
                {t('nav.team')}
              </Button>
            </ListItemButton>
          </ListItem>

          {/* FAQ */}
          <ListItem disablePadding>
            <ListItemButton>
              <Button 
                sx={navButtonStyle} 
                startIcon={<VectorIcon />} 
                onClick={() => handleStandardNav("FAQ")}
              >
                {t('nav.faq')}
              </Button>
            </ListItemButton>
          </ListItem>

          {/* Publications */}
          <ListItem disablePadding>
            <ListItemButton>
              <Button 
                sx={navButtonStyle} 
                startIcon={<PostAddOutlinedIcon />} 
                onClick={() => handleStandardNav("Publications")}
              >
                {t('nav.publications')}
              </Button>
            </ListItemButton>
          </ListItem>

          {/* Join Button */}
          <ListItem disablePadding>
            <ListItemButton>
              <Button
                sx={joinButtonStyle}
                onClick={() => window.open("https://www.redcap.link/wisdomibdstudy", "_blank")}
              >
                {t('landing.join_button')}
              </Button>
            </ListItemButton>
          </ListItem>
        </List>
        
        <Divider sx={{ my: 2 }} />

        {/* Language Switcher Section */}
        <Box sx={{ px: 2, pb: 2 }}>
          <Button 
            variant="outlined" 
            fullWidth
            onClick={() => changeLanguage(i18n.language === 'en' ? 'es' : 'en')}
            sx={{ 
              borderRadius: "20px", 
              borderColor: "#D80C8C", 
              color: "#D80C8C", 
              fontWeight: "bold",
              textTransform: "none" 
            }}
          >
            {i18n.language === 'en' ? 'Switch to Español' : 'Cambiar a English'}
          </Button>
        </Box>


      </Box>
    </Drawer>
  );
};

// Extracted styles for cleaner JSX
const navButtonStyle = {
  color: "rgba(68, 71, 80, 1)",
  textTransform: "none",
  fontSize: "14px",
  fontWeight: 400,
  justifyContent: "flex-start",
  width: "100%"
};

const joinButtonStyle = {
  fontWeight: 500,
  fontSize: "14px",
  color: "#FFFFFF",
  backgroundColor: "#D80C8C",
  padding: "8px 16px",
  borderRadius: "10px",
  "&:hover": { backgroundColor: "#D80C8C" },
  textTransform: "none",
  minWidth: "auto",
  width: "100%",
  marginTop: "10px"
};

export default MobileDrawer;